// SC-2445 — the internal catalog-section vocabulary + ARIA id helpers. Kept out of
// any component file so the canvas view tabs + each section route can share the id
// helpers without tripping react-refresh's "only export components" rule. The URL
// and the canvas shell speak `CanvasView` (SC-2670); `canvasNav.viewToTab` bridges a
// view to the `CatalogTab` these ARIA ids key on.

// Catalog-section tabs. The set is intentionally extensible — future sections
// (Insights, Integrations, …) slot in here.
export type CatalogTab = 'table' | 'attributes' | 'findings' | 'profile' | 'changes';

// Stable ids so the rendered content regions can wire `role="tabpanel"` +
// `aria-labelledby` back to their tab.
export const catalogTabId = (tab: CatalogTab) => `catalog-tab-${tab}`;
export const catalogTabPanelId = (tab: CatalogTab) => `catalog-tabpanel-${tab}`;

// Board tabs (SC-2873) are dynamic — keyed by board id rather than the closed
// `CatalogTab` set. Same tab ↔ panel wiring contract as the core sections.
export const boardTabId = (boardId: string) => `catalog-tab-board-${boardId}`;
export const boardTabPanelId = (boardId: string) => `catalog-tabpanel-board-${boardId}`;
